/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NotificationsEmailTokenResponseSchema
 */
export interface NotificationsEmailTokenResponseSchema {
    /**
     * 
     * @type {string}
     * @memberof NotificationsEmailTokenResponseSchema
     */
    token: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationsEmailTokenResponseSchema
     */
    email: string;
}

/**
 * Check if a given object implements the NotificationsEmailTokenResponseSchema interface.
 */
export function instanceOfNotificationsEmailTokenResponseSchema(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "token" in value;
    isInstance = isInstance && "email" in value;

    return isInstance;
}

export function NotificationsEmailTokenResponseSchemaFromJSON(json: any): NotificationsEmailTokenResponseSchema {
    return NotificationsEmailTokenResponseSchemaFromJSONTyped(json, false);
}

export function NotificationsEmailTokenResponseSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): NotificationsEmailTokenResponseSchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'token': json['token'],
        'email': json['email'],
    };
}

export function NotificationsEmailTokenResponseSchemaToJSON(value?: NotificationsEmailTokenResponseSchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'token': value.token,
        'email': value.email,
    };
}

